module.exports = __webpack_public_path__ + "static/media/pit4.439b3033.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pioricost-fruit/pitahaya/pit4.jpeg
// module id = 45
// module chunks = 0